/**
 * pp-paco-cta — handler global de CTAs que abren el asistente Paco.
 *
 * Cualquier elemento con `data-pp-paco-prompt="texto del mensaje"` se
 * convierte en un trigger: al hacer click, si <pp-assistant> está
 * montado en la página, intercepta y dispara `pp-assistant:open` con
 * el texto como detail.message. Si Paco no está, el click cae al
 * comportamiento nativo (href fallback).
 *
 * LO CARGA snippets/pp-assistant.liquid, NO LAS SECCIONES.
 * Hasta el 25-ago-2026 lo cargaba cada sección con su propio <script src>:
 * diecisiete lo hacían y nueve no, y como el handler es global y delegado en
 * `document`, una sección sin script funcionaba igual si otra sección de la
 * misma plantilla sí lo traía. El resultado fueron DIEZ plantillas con botón
 * de Paco y cero handler —ventas, servicio al cliente, proveedores, contacto,
 * preguntas frecuentes, reseñas, sobre nosotros, gracias, mapa del sitio y la
 * genérica page.static— con el botón pintado, sin error en consola y sin
 * hacer nada al click. Ahora vive con el snippet que monta <pp-assistant>,
 * que el layout renderiza en todas las páginas, así que la categoría "sección
 * a la que se le olvidó el script" ya no existe.
 *
 * Patrón: event delegation desde document, sobrevive section reloads
 * del customizer. Idempotente vía data-pp-paco-cta-bound en document.
 *
 * Lo vigila tests/paco-cta-en-toda-la-tienda.test.mjs.
 */
(function () {
  'use strict';

  if (document.documentElement.dataset.ppPacoCtaBound === '1') return;
  document.documentElement.dataset.ppPacoCtaBound = '1';

  function abrir(message) {
    // Sin mensaje mandamos el detail vacío: `_onExternalOpen` del asistente
    // hace `if (detail.message)`, así que abre el panel y no manda nada.
    document.dispatchEvent(
      new CustomEvent('pp-assistant:open', {
        detail: message ? { message: message } : {}
      })
    );
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-pp-paco-prompt],[data-pp-open-paco]');
    if (!el) return;

    if (!document.querySelector('pp-assistant')) return;

    /**
     * Dos marcadores, un solo camino:
     *
     *   data-pp-paco-prompt="…"  abre el chat Y manda ese mensaje
     *   data-pp-open-paco        abre el chat y ya
     *
     * El segundo lo usa el CTA de /pages/sobre-nosotros, que hasta el
     * 25-ago-2026 traía su propio wire en la sección y disparaba
     * `pp:assistant:open` — con dos puntos. El asistente escucha
     * `pp-assistant:open`, con guion. Nunca abrió. Y su fallback era darle
     * click a `#pp-chat-btn`, el botón del chat humano que está deprecado
     * (`settings.chat_enabled = false`) y ni se renderiza: verificado, cero
     * ocurrencias en el HTML servido. O sea que el botón tenía dos salidas y
     * las dos estaban tapiadas.
     *
     * Un prompt vacío NO abre: quiere decir que el setting de Liquid quedó en
     * blanco, y en ese caso el click tiene que caer al href de la sección.
     */
    var message = (el.getAttribute('data-pp-paco-prompt') || '').trim();
    if (el.hasAttribute('data-pp-paco-prompt') && !message) return;

    e.preventDefault();

    /**
     * <pp-assistant> viaja en el HTML de todas las páginas, pero hasta que
     * corre customElements.define es un tag inerte: quien escucha
     * `pp-assistant:open` es connectedCallback, y ese solo corre al hacerse
     * el upgrade. Y pp-assistant.js son 192 KB que bajan en
     * requestIdleCallback (timeout 1.5-3 s), así que hay una ventana real al
     * principio de cada página en la que el elemento existe, el guard de
     * arriba pasa, y el evento se dispara cuando todavía no hay nadie del
     * otro lado. Ahí el click se pierde en silencio.
     *
     * El click ya arranca la descarga por su cuenta: el snippet escucha en
     * fase de captura sobre estos mismos selectores. Aquí solo esperamos a
     * que el elemento esté definido para disparar UNA vez —whenDefined
     * resuelve después del upgrade, así que connectedCallback ya registró su
     * listener—. Dos dispatch abrirían el chat una vez pero mandarían el
     * mensaje dos veces.
     */
    if (!window.customElements || customElements.get('pp-assistant')) {
      abrir(message);
      return;
    }
    customElements.whenDefined('pp-assistant').then(function () {
      abrir(message);
    });
  });
})();
